// src/components/WantAdEditor/index.jsx  (wrapper + code-splitting)
import React, { Suspense, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { useAppConfig } from "@/appConfig";
import { pageURLs } from "@/constants";

export default function AgentWantAdDraftEditor(props) {
  const { flags } = useAppConfig();

  if (flags.aiCreateFlow) {
    return <Navigate to={pageURLs.agentCreatewantad} replace />;
  }

  const LazyEditor = useMemo(() => {
    return React.lazy(() =>
      flags.mlsAgentEditor
        ? import("./MLSAgentCreateOrEditWantAdDraftListing")
        : import("./AgentCreateOrEditWantAdDraftListing"),
    );
  }, [flags.mlsAgentEditor]);

  return (
    <Suspense fallback={null}>
      <LazyEditor {...props} />
    </Suspense>
  );
}
